export const DEFAULT_COUNTRY_CODE = "FR";

export const CORPORATE_COUNTRIES_FR = [
  { id: "BEL", label: "Belgique" },
  { id: "BGR", label: "Bulgarie" },
  { id: "CYP", label: "Chypre" },
  { id: "DNK", label: "Danemark" },
  { id: "DEU", label: "Allemagne" },
  { id: "EST", label: "Estonie" },
  { id: "FIN", label: "Finlande" },
  { id: "FRA", label: "France" },
  { id: "GBR", label: "Royaume-Uni" },
  { id: "GRC", label: "Grèce" },
  { id: "HUN", label: "Hongrie" },
  { id: "IRL", label: "Irlande" },
  { id: "ISL", label: "Islande" },
  { id: "ITA", label: "Italie" },
  { id: "HRV", label: "Croatie" },
  { id: "LVA", label: "Lettonie" },
  { id: "LIE", label: "Liechtenstein" },
  { id: "LTU", label: "Lituanie" },
  { id: "LUX", label: "Luxembourg" },
  { id: "MLT", label: "Malte" },
  { id: "NLD", label: "Pays-Bas" },
  { id: "NOR", label: "Norvège" },
  { id: "AUT", label: "Autriche" },
  { id: "POL", label: "Pologne" },
  { id: "PRT", label: "Portugal" },
  { id: "ROU", label: "Roumanie" },
  { id: "SVN", label: "Slovénie" },
  { id: "SVK", label: "Slovaquie" },
  { id: "ESP", label: "Espagne" },
  { id: "CZE", label: "Tchéquie" },
  { id: "SWE", label: "Suède" },
];

export const CORPORATE_COUNTRIES_EN = [
  { id: "BEL", label: "Belgium" },
  { id: "BGR", label: "Bulgaria" },
  { id: "CYP", label: "Cyprus" },
  { id: "DNK", label: "Denmark" },
  { id: "DEU", label: "Germany" },
  { id: "EST", label: "Estonia" },
  { id: "FIN", label: "Finland" },
  { id: "FRA", label: "France" },
  { id: "GBR", label: "United Kingdom" },
  { id: "GRC", label: "Greece" },
  { id: "HUN", label: "Hungary" },
  { id: "IRL", label: "Ireland" },
  { id: "ISL", label: "Iceland" },
  { id: "ITA", label: "Italy" },
  { id: "HRV", label: "Croatia" },
  { id: "LVA", label: "Latvia" },
  { id: "LIE", label: "Liechtenstein" },
  { id: "LTU", label: "Lithuania" },
  { id: "LUX", label: "Luxembourg" },
  { id: "MLT", label: "Malta" },
  { id: "NLD", label: "Netherlands" },
  { id: "NOR", label: "Norway" },
  { id: "AUT", label: "Austria" },
  { id: "POL", label: "Poland" },
  { id: "PRT", label: "Portugal" },
  { id: "ROU", label: "Romania" },
  { id: "SVN", label: "Slovenia" },
  { id: "SVK", label: "Slovakia" },
  { id: "ESP", label: "Spain" },
  { id: "CZE", label: "Czech Republic" },
  { id: "SWE", label: "Sweden" },
];

export const COUNTRIES_FR = [
  { id: "ABW", label: "Aruba" },
  { id: "AFG", label: "Afghanistan" },
  { id: "AGO", label: "Angola" },
  { id: "AIA", label: "Anguilla" },
  { id: "ALA", label: "Îles Åland" },
  { id: "ALB", label: "Albanie" },
  { id: "AND", label: "Andorre" },
  { id: "ARE", label: "Émirats arabes unis" },
  { id: "ARG", label: "Argentine" },
  { id: "ARM", label: "Arménie" },
  { id: "ASM", label: "Samoa américaines" },
  { id: "ATA", label: "Antarctique" },
  { id: "ATF", label: "Terres australes françaises" },
  { id: "ATG", label: "Antigua-et-Barbuda" },
  { id: "AUS", label: "Australie" },
  { id: "AUT", label: "Autriche" },
  { id: "AZE", label: "Azerbaïdjan" },
  { id: "BDI", label: "Burundi" },
  { id: "BEL", label: "Belgique" },
  { id: "BEN", label: "Bénin" },
  { id: "BES", label: "Pays-Bas caribéens" },
  { id: "BFA", label: "Burkina Faso" },
  { id: "BGD", label: "Bangladesh" },
  { id: "BGR", label: "Bulgarie" },
  { id: "BHR", label: "Bahreïn" },
  { id: "BHS", label: "Bahamas" },
  { id: "BIH", label: "Bosnie-Herzégovine" },
  { id: "BLM", label: "Saint-Barthélemy" },
  { id: "BLR", label: "Bélarus" },
  { id: "BLZ", label: "Belize" },
  { id: "BMU", label: "Bermudes" },
  { id: "BOL", label: "Bolivie" },
  { id: "BRA", label: "Brésil" },
  { id: "BRB", label: "Barbade" },
  { id: "BRN", label: "Brunei" },
  { id: "BTN", label: "Bhoutan" },
  { id: "BVT", label: "Île Bouvet" },
  { id: "BWA", label: "Botswana" },
  { id: "CAF", label: "République centrafricaine" },
  { id: "CAN", label: "Canada" },
  { id: "CCK", label: "Îles Cocos" },
  { id: "CHE", label: "Suisse" },
  { id: "CHL", label: "Chili" },
  { id: "CHN", label: "Chine" },
  { id: "CIV", label: "Côte d'Ivoire" },
  { id: "CMR", label: "Cameroun" },
  { id: "COD", label: "République démocratique du Congo" },
  { id: "COG", label: "République du Congo" },
  { id: "COK", label: "Îles Cook" },
  { id: "COL", label: "Colombie" },
  { id: "COM", label: "Comores" },
  { id: "CPV", label: "Cap-Vert" },
  { id: "CRI", label: "Costa Rica" },
  { id: "CUB", label: "Cuba" },
  { id: "CUW", label: "Curaçao" },
  { id: "CXR", label: "Île Christmas" },
  { id: "CYM", label: "Îles Caïmans" },
  { id: "CYP", label: "Chypre" },
  { id: "CZE", label: "Tchéquie" },
  { id: "DEU", label: "Allemagne" },
  { id: "DJI", label: "Djibouti" },
  { id: "DMA", label: "Dominique" },
  { id: "DNK", label: "Danemark" },
  { id: "DOM", label: "République dominicaine" },
  { id: "DZA", label: "Algérie" },
  { id: "ECU", label: "Équateur" },
  { id: "EGY", label: "Égypte" },
  { id: "ERI", label: "Érythrée" },
  { id: "ESH", label: "Sahara occidental" },
  { id: "ESP", label: "Espagne" },
  { id: "EST", label: "Estonie" },
  { id: "ETH", label: "Éthiopie" },
  { id: "FIN", label: "Finlande" },
  { id: "FJI", label: "Fidji" },
  { id: "FLK", label: "Îles Malouines" },
  { id: "FRA", label: "France" },
  { id: "FRO", label: "Îles Féroé" },
  { id: "FSM", label: "États fédérés de Micronésie" },
  { id: "GAB", label: "Gabon" },
  { id: "GBR", label: "Royaume-Uni" },
  { id: "GEO", label: "Géorgie" },
  { id: "GGY", label: "Guernesey" },
  { id: "GHA", label: "Ghana" },
  { id: "GIB", label: "Gibraltar" },
  { id: "GIN", label: "Guinée" },
  { id: "GMB", label: "Gambie" },
  { id: "GNB", label: "Guinée-Bissau" },
  { id: "GNQ", label: "Guinée équatoriale" },
  { id: "GRC", label: "Grèce" },
  { id: "GRD", label: "Grenade" },
  { id: "GRL", label: "Groenland" },
  { id: "GTM", label: "Guatemala" },
  { id: "GUM", label: "Guam" },
  { id: "GUY", label: "Guyana" },
  { id: "HKG", label: "Hong Kong" },
  { id: "HMD", label: "Îles Heard-et-MacDonald" },
  { id: "HND", label: "Honduras" },
  { id: "HRV", label: "Croatie" },
  { id: "HTI", label: "Haïti" },
  { id: "HUN", label: "Hongrie" },
  { id: "IDN", label: "Indonésie" },
  { id: "IMN", label: "Île de Man" },
  { id: "IND", label: "Inde" },
  { id: "IOT", label: "Territoire britannique de l'océan Indien" },
  { id: "IRL", label: "Irlande" },
  { id: "IRN", label: "Iran" },
  { id: "IRQ", label: "Irak" },
  { id: "ISL", label: "Islande" },
  { id: "ISR", label: "Israël" },
  { id: "ITA", label: "Italie" },
  { id: "JAM", label: "Jamaïque" },
  { id: "JEY", label: "Jersey" },
  { id: "JOR", label: "Jordanie" },
  { id: "JPN", label: "Japon" },
  { id: "KAZ", label: "Kazakhstan" },
  { id: "KEN", label: "Kenya" },
  { id: "KGZ", label: "Kirghizistan" },
  { id: "KHM", label: "Cambodge" },
  { id: "KIR", label: "Kiribati" },
  { id: "KNA", label: "Saint-Christophe-et-Niévès" },
  { id: "KOR", label: "Corée du Sud" },
  { id: "KWT", label: "Koweït" },
  { id: "LAO", label: "Laos" },
  { id: "LBN", label: "Liban" },
  { id: "LBR", label: "Libéria" },
  { id: "LBY", label: "Libye" },
  { id: "LCA", label: "Sainte-Lucie" },
  { id: "LIE", label: "Liechtenstein" },
  { id: "LKA", label: "Sri Lanka" },
  { id: "LSO", label: "Lesotho" },
  { id: "LTU", label: "Lituanie" },
  { id: "LUX", label: "Luxembourg" },
  { id: "LVA", label: "Lettonie" },
  { id: "MAC", label: "Macao" },
  { id: "MAF", label: "Saint-Martin (partie française)" },
  { id: "MAR", label: "Maroc" },
  { id: "MCO", label: "Monaco" },
  { id: "MDA", label: "Moldavie" },
  { id: "MDG", label: "Madagascar" },
  { id: "MDV", label: "Maldives" },
  { id: "MEX", label: "Mexique" },
  { id: "MHL", label: "Îles Marshall" },
  { id: "MKD", label: "Macédoine du Nord" },
  { id: "MLI", label: "Mali" },
  { id: "MLT", label: "Malte" },
  { id: "MMR", label: "Birmanie (Myanmar)" },
  { id: "MNE", label: "Monténégro" },
  { id: "MNG", label: "Mongolie" },
  { id: "MNP", label: "Îles Mariannes du Nord" },
  { id: "MOZ", label: "Mozambique" },
  { id: "MRT", label: "Mauritanie" },
  { id: "MSR", label: "Montserrat" },
  { id: "MUS", label: "Maurice" },
  { id: "MWI", label: "Malawi" },
  { id: "MYS", label: "Malaisie" },
  { id: "NAM", label: "Namibie" },
  { id: "NCL", label: "Nouvelle-Calédonie" },
  { id: "NER", label: "Niger" },
  { id: "NFK", label: "Île Norfolk" },
  { id: "NGA", label: "Nigéria" },
  { id: "NIC", label: "Nicaragua" },
  { id: "NIU", label: "Niue" },
  { id: "NLD", label: "Pays-Bas" },
  { id: "NOR", label: "Norvège" },
  { id: "NPL", label: "Népal" },
  { id: "NRU", label: "Nauru" },
  { id: "NZL", label: "Nouvelle-Zélande" },
  { id: "OMN", label: "Oman" },
  { id: "PAK", label: "Pakistan" },
  { id: "PAN", label: "Panama" },
  { id: "PCN", label: "Pitcairn" },
  { id: "PER", label: "Pérou" },
  { id: "PHL", label: "Philippines" },
  { id: "PLW", label: "Palaos" },
  { id: "PNG", label: "Papouasie-Nouvelle-Guinée" },
  { id: "POL", label: "Pologne" },
  { id: "PRI", label: "Porto Rico" },
  { id: "PRK", label: "Corée du Nord" },
  { id: "PRT", label: "Portugal" },
  { id: "PRY", label: "Paraguay" },
  { id: "PSE", label: "Palestine" },
  { id: "PYF", label: "Polynésie française" },
  { id: "QAT", label: "Qatar" },
  { id: "ROU", label: "Roumanie" },
  { id: "RUS", label: "Russie" },
  { id: "RWA", label: "Rwanda" },
  { id: "SAU", label: "Arabie saoudite" },
  { id: "SDN", label: "Soudan" },
  { id: "SEN", label: "Sénégal" },
  { id: "SGP", label: "Singapour" },
  { id: "SGS", label: "Géorgie du Sud-et-les Îles Sandwich du Sud" },
  { id: "SHN", label: "Sainte-Hélène, Ascension et Tristan da Cunha" },
  { id: "SJM", label: "Svalbard et Île Jan Mayen" },
  { id: "SLB", label: "Îles Salomon" },
  { id: "SLE", label: "Sierra Leone" },
  { id: "SLV", label: "Salvador" },
  { id: "SMR", label: "Saint-Marin" },
  { id: "SOM", label: "Somalie" },
  { id: "SPM", label: "Saint-Pierre-et-Miquelon" },
  { id: "SRB", label: "Serbie" },
  { id: "SSD", label: "Soudan du Sud" },
  { id: "STP", label: "Sao Tomé-et-Principe" },
  { id: "SUR", label: "Suriname" },
  { id: "SVK", label: "Slovaquie" },
  { id: "SVN", label: "Slovénie" },
  { id: "SWE", label: "Suède" },
  { id: "SWZ", label: "Eswatini (Swaziland)" },
  { id: "SXM", label: "Saint-Martin (partie néerlandaise)" },
  { id: "SYC", label: "Seychelles" },
  { id: "SYR", label: "Syrie" },
  { id: "TCA", label: "Îles Turques-et-Caïques" },
  { id: "TCD", label: "Tchad" },
  { id: "TGO", label: "Togo" },
  { id: "THA", label: "Thaïlande" },
  { id: "TJK", label: "Tadjikistan" },
  { id: "TKL", label: "Tokelau" },
  { id: "TKM", label: "Turkménistan" },
  { id: "TLS", label: "Timor-Leste" },
  { id: "TON", label: "Tonga" },
  { id: "TTO", label: "Trinité-et-Tobago" },
  { id: "TUN", label: "Tunisie" },
  { id: "TUR", label: "Turquie" },
  { id: "TUV", label: "Tuvalu" },
  { id: "TWN", label: "Taïwan" },
  { id: "TZA", label: "Tanzanie" },
  { id: "UGA", label: "Ouganda" },
  { id: "UKR", label: "Ukraine" },
  { id: "UMI", label: "Îles mineures éloignées des États-Unis" },
  { id: "URY", label: "Uruguay" },
  { id: "USA", label: "États-Unis" },
  { id: "UZB", label: "Ouzbékistan" },
  { id: "VAT", label: "Vatican" },
  { id: "VCT", label: "Saint-Vincent-et-les-Grenadines" },
  { id: "VEN", label: "Venezuela" },
  { id: "VGB", label: "Îles Vierges britanniques" },
  { id: "VIR", label: "Îles Vierges des États-Unis" },
  { id: "VNM", label: "Vietnam" },
  { id: "VUT", label: "Vanuatu" },
  { id: "WLF", label: "Wallis-et-Futuna" },
  { id: "WSM", label: "Samoa" },
  { id: "XXK", label: "Kosovo" },
  { id: "YEM", label: "Yémen" },
  { id: "ZAF", label: "Afrique du Sud" },
  { id: "ZMB", label: "Zambie" },
  { id: "ZWE", label: "Zimbabwe" },
];

export const COUNTRIES_EN = [
  { id: "ABW", label: "Aruba" },
  { id: "AFG", label: "Afghanistan" },
  { id: "AGO", label: "Angola" },
  { id: "AIA", label: "Anguilla" },
  { id: "ALA", label: "Åland Islands" },
  { id: "ALB", label: "Albania" },
  { id: "AND", label: "Andorra" },
  { id: "ARE", label: "United Arab Emirates" },
  { id: "ARG", label: "Argentina" },
  { id: "ARM", label: "Armenia" },
  { id: "ASM", label: "American Samoa" },
  { id: "ATA", label: "Antarctica" },
  { id: "ATF", label: "French Southern Territories" },
  { id: "ATG", label: "Antigua and Barbuda" },
  { id: "AUS", label: "Australia" },
  { id: "AUT", label: "Austria" },
  { id: "AZE", label: "Azerbaijan" },
  { id: "BDI", label: "Burundi" },
  { id: "BEL", label: "Belgium" },
  { id: "BEN", label: "Benin" },
  { id: "BES", label: "Caribbean Netherlands" },
  { id: "BFA", label: "Burkina Faso" },
  { id: "BGD", label: "Bangladesh" },
  { id: "BGR", label: "Bulgaria" },
  { id: "BHR", label: "Bahrain" },
  { id: "BHS", label: "Bahamas" },
  { id: "BIH", label: "Bosnia and Herzegovina" },
  { id: "BLM", label: "Saint Barthélemy" },
  { id: "BLR", label: "Belarus" },
  { id: "BLZ", label: "Belize" },
  { id: "BMU", label: "Bermuda" },
  { id: "BOL", label: "Bolivia" },
  { id: "BRA", label: "Brazil" },
  { id: "BRB", label: "Barbados" },
  { id: "BRN", label: "Brunei" },
  { id: "BTN", label: "Bhutan" },
  { id: "BVT", label: "Bouvet Island" },
  { id: "BWA", label: "Botswana" },
  { id: "CAF", label: "Central African Republic" },
  { id: "CAN", label: "Canada" },
  { id: "CCK", label: "Cocos (Keeling) Islands" },
  { id: "CHE", label: "Switzerland" },
  { id: "CHL", label: "Chile" },
  { id: "CHN", label: "China" },
  { id: "CIV", label: "Côte d'Ivoire" },
  { id: "CMR", label: "Cameroon" },
  { id: "COD", label: "Democratic Republic of the Congo" },
  { id: "COG", label: "Congo" },
  { id: "COK", label: "Cook Islands" },
  { id: "COL", label: "Colombia" },
  { id: "COM", label: "Comoros" },
  { id: "CPV", label: "Cape Verde" },
  { id: "CRI", label: "Costa Rica" },
  { id: "CUB", label: "Cuba" },
  { id: "CUW", label: "Curaçao" },
  { id: "CXR", label: "Christmas Island" },
  { id: "CYM", label: "Cayman Islands" },
  { id: "CYP", label: "Cyprus" },
  { id: "CZE", label: "Czech Republic" },
  { id: "DEU", label: "Germany" },
  { id: "DJI", label: "Djibouti" },
  { id: "DMA", label: "Dominica" },
  { id: "DNK", label: "Denmark" },
  { id: "DOM", label: "Dominican Republic" },
  { id: "DZA", label: "Algeria" },
  { id: "ECU", label: "Ecuador" },
  { id: "EGY", label: "Egypt" },
  { id: "ERI", label: "Eritrea" },
  { id: "ESH", label: "Western Sahara" },
  { id: "ESP", label: "Spain" },
  { id: "EST", label: "Estonia" },
  { id: "ETH", label: "Ethiopia" },
  { id: "FIN", label: "Finland" },
  { id: "FJI", label: "Fiji" },
  { id: "FLK", label: "Falkland Islands" },
  { id: "FRA", label: "France" },
  { id: "FRO", label: "Faroe Islands" },
  { id: "FSM", label: "Micronesia" },
  { id: "GAB", label: "Gabon" },
  { id: "GBR", label: "United Kingdom" },
  { id: "GEO", label: "Georgia" },
  { id: "GGY", label: "Guernsey" },
  { id: "GHA", label: "Ghana" },
  { id: "GIB", label: "Gibraltar" },
  { id: "GIN", label: "Guinea" },
  { id: "GMB", label: "Gambia" },
  { id: "GNB", label: "Guinea-Bissau" },
  { id: "GNQ", label: "Equatorial Guinea" },
  { id: "GRC", label: "Greece" },
  { id: "GRD", label: "Grenada" },
  { id: "GRL", label: "Greenland" },
  { id: "GTM", label: "Guatemala" },
  { id: "GUM", label: "Guam" },
  { id: "GUY", label: "Guyana" },
  { id: "HKG", label: "Hong Kong" },
  { id: "HMD", label: "Heard Island and McDonald Islands" },
  { id: "HND", label: "Honduras" },
  { id: "HRV", label: "Croatia" },
  { id: "HTI", label: "Haiti" },
  { id: "HUN", label: "Hungary" },
  { id: "IDN", label: "Indonesia" },
  { id: "IMN", label: "Isle of Man" },
  { id: "IND", label: "India" },
  { id: "IOT", label: "British Indian Ocean Territory" },
  { id: "IRL", label: "Ireland" },
  { id: "IRN", label: "Iran" },
  { id: "IRQ", label: "Iraq" },
  { id: "ISL", label: "Iceland" },
  { id: "ISR", label: "Israel" },
  { id: "ITA", label: "Italy" },
  { id: "JAM", label: "Jamaica" },
  { id: "JEY", label: "Jersey" },
  { id: "JOR", label: "Jordan" },
  { id: "JPN", label: "Japan" },
  { id: "KAZ", label: "Kazakhstan" },
  { id: "KEN", label: "Kenya" },
  { id: "KGZ", label: "Kyrgyzstan" },
  { id: "KHM", label: "Cambodia" },
  { id: "KIR", label: "Kiribati" },
  { id: "KNA", label: "Saint Kitts and Nevis" },
  { id: "KOR", label: "South Korea" },
  { id: "KWT", label: "Kuwait" },
  { id: "LAO", label: "Laos" },
  { id: "LBN", label: "Lebanon" },
  { id: "LBR", label: "Liberia" },
  { id: "LBY", label: "Libya" },
  { id: "LCA", label: "Saint Lucia" },
  { id: "LIE", label: "Liechtenstein" },
  { id: "LKA", label: "Sri Lanka" },
  { id: "LSO", label: "Lesotho" },
  { id: "LTU", label: "Lithuania" },
  { id: "LUX", label: "Luxembourg" },
  { id: "LVA", label: "Latvia" },
  { id: "MAC", label: "Macao" },
  { id: "MAF", label: "Saint Martin (French part)" },
  { id: "MAR", label: "Morocco" },
  { id: "MCO", label: "Monaco" },
  { id: "MDA", label: "Moldova" },
  { id: "MDG", label: "Madagascar" },
  { id: "MDV", label: "Maldives" },
  { id: "MEX", label: "Mexico" },
  { id: "MHL", label: "Marshall Islands" },
  { id: "MKD", label: "North Macedonia" },
  { id: "MLI", label: "Mali" },
  { id: "MLT", label: "Malta" },
  { id: "MMR", label: "Myanmar (Burma)" },
  { id: "MNE", label: "Montenegro" },
  { id: "MNG", label: "Mongolia" },
  { id: "MNP", label: "Northern Mariana Islands" },
  { id: "MOZ", label: "Mozambique" },
  { id: "MRT", label: "Mauritania" },
  { id: "MSR", label: "Montserrat" },
  { id: "MUS", label: "Mauritius" },
  { id: "MWI", label: "Malawi" },
  { id: "MYS", label: "Malaysia" },
  { id: "NAM", label: "Namibia" },
  { id: "NCL", label: "New Caledonia" },
  { id: "NER", label: "Niger" },
  { id: "NFK", label: "Norfolk Island" },
  { id: "NGA", label: "Nigeria" },
  { id: "NIC", label: "Nicaragua" },
  { id: "NIU", label: "Niue" },
  { id: "NLD", label: "Netherlands" },
  { id: "NOR", label: "Norway" },
  { id: "NPL", label: "Nepal" },
  { id: "NRU", label: "Nauru" },
  { id: "NZL", label: "New Zealand" },
  { id: "OMN", label: "Oman" },
  { id: "PAK", label: "Pakistan" },
  { id: "PAN", label: "Panama" },
  { id: "PCN", label: "Pitcairn Islands" },
  { id: "PER", label: "Peru" },
  { id: "PHL", label: "Philippines" },
  { id: "PLW", label: "Palau" },
  { id: "PNG", label: "Papua New Guinea" },
  { id: "POL", label: "Poland" },
  { id: "PRI", label: "Puerto Rico" },
  { id: "PRK", label: "North Korea" },
  { id: "PRT", label: "Portugal" },
  { id: "PRY", label: "Paraguay" },
  { id: "PSE", label: "Palestine" },
  { id: "PYF", label: "French Polynesia" },
  { id: "QAT", label: "Qatar" },
  { id: "ROU", label: "Romania" },
  { id: "RUS", label: "Russia" },
  { id: "RWA", label: "Rwanda" },
  { id: "SAU", label: "Saudi Arabia" },
  { id: "SDN", label: "Sudan" },
  { id: "SEN", label: "Senegal" },
  { id: "SGP", label: "Singapore" },
  { id: "SGS", label: "South Georgia and the South Sandwich Islands" },
  { id: "SHN", label: "Saint Helena, Ascension and Tristan da Cunha" },
  { id: "SJM", label: "Svalbard and Jan Mayen" },
  { id: "SLB", label: "Solomon Islands" },
  { id: "SLE", label: "Sierra Leone" },
  { id: "SLV", label: "El Salvador" },
  { id: "SMR", label: "San Marino" },
  { id: "SOM", label: "Somalia" },
  { id: "SPM", label: "Saint Pierre and Miquelon" },
  { id: "SRB", label: "Serbia" },
  { id: "SSD", label: "South Sudan" },
  { id: "STP", label: "São Tomé and Príncipe" },
  { id: "SUR", label: "Suriname" },
  { id: "SVK", label: "Slovakia" },
  { id: "SVN", label: "Slovenia" },
  { id: "SWE", label: "Sweden" },
  { id: "SWZ", label: "Eswatini" },
  { id: "SXM", label: "Sint Maarten (Dutch part)" },
  { id: "SYC", label: "Seychelles" },
  { id: "SYR", label: "Syria" },
  { id: "TCA", label: "Turks and Caicos Islands" },
  { id: "TCD", label: "Chad" },
  { id: "TGO", label: "Togo" },
  { id: "THA", label: "Thailand" },
  { id: "TJK", label: "Tajikistan" },
  { id: "TKL", label: "Tokelau" },
  { id: "TKM", label: "Turkmenistan" },
  { id: "TLS", label: "Timor-Leste" },
  { id: "TON", label: "Tonga" },
  { id: "TTO", label: "Trinidad and Tobago" },
  { id: "TUN", label: "Tunisia" },
  { id: "TUR", label: "Turkey" },
  { id: "TUV", label: "Tuvalu" },
  { id: "TWN", label: "Taiwan" },
  { id: "TZA", label: "Tanzania" },
  { id: "UGA", label: "Uganda" },
  { id: "UKR", label: "Ukraine" },
  { id: "UMI", label: "United States Minor Outlying Islands" },
  { id: "URY", label: "Uruguay" },
  { id: "USA", label: "United States" },
  { id: "UZB", label: "Uzbekistan" },
  { id: "VAT", label: "Vatican City" },
  { id: "VCT", label: "Saint Vincent and the Grenadines" },
  { id: "VEN", label: "Venezuela" },
  { id: "VGB", label: "British Virgin Islands" },
  { id: "VIR", label: "U.S. Virgin Islands" },
  { id: "VNM", label: "Vietnam" },
  { id: "VUT", label: "Vanuatu" },
  { id: "WLF", label: "Wallis and Futuna" },
  { id: "WSM", label: "Samoa" },
  { id: "XXK", label: "Kosovo" },
  { id: "YEM", label: "Yemen" },
  { id: "ZAF", label: "South Africa" },
  { id: "ZMB", label: "Zambia" },
  { id: "ZWE", label: "Zimbabwe" },
];
